import React, { useMemo } from 'react'
import cx from 'classnames'

import BlockContent from 'src/components/global/BlockContent'

import { createEditorialSerializer } from 'src/utils/editorialSerializer'
import { getPortableTextHeading } from 'src/utils/ctaTracking'

export interface EditorialTextProps {
  data: {
    editorialText: any[]
    backgroundColor: string
    spacing: string
    containerSize: string
  }
}

export const EditorialText = ({ data }: EditorialTextProps) => {
  const { editorialText, spacing, backgroundColor } = data
  const serializers = useMemo(
    () => createEditorialSerializer({ module: 'Editorial text module', heading: getPortableTextHeading(editorialText, 'Editorial text') }),
    [editorialText]
  )

  return (
    <div
      className={cx(backgroundColor, spacing, {
        cw: backgroundColor === 'bcb',
      })}
    >
      <div className="editorial__core">
        <BlockContent
          blocks={editorialText}
          serializers={serializers}
        />
      </div>
    </div>
  )
}
